<template lang="html">
  <section class="app-read-subscriber" role="tablist">
    <b-card no-body class="mb-1" :key="idx" v-for="(subscriber, idx) in subscribers">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="" v-b-toggle="'accordion-'+idx" variant="light">{{subscriber.email}}</b-button>
      </b-card-header>
      <b-collapse :id="'accordion-'+idx" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text class="d-flex">
            <div class="d-flex flex-wrap justify-content-between">
              <div><strong>email : </strong>{{subscriber.email}}</div>
              <div><strong>date_created : </strong>{{subscriber.date_created}}</div>
              <div><strong>date_updated : </strong>{{subscriber.date_updated}}</div>
              <div><strong>unsubscribed : </strong>{{subscriber.unsubscribed}}</div>
            </div>
          </b-card-text>
          <b-card-text class="mt-4 text-center">
            <button type="button" class="btn btn-primary"
                    @click="navigateAway({id: subscriber.email, title: subscriber.email}, 'update')">
              Update
            </button>
            <button type="button" class="btn btn-danger ml-3"
                    @click="navigateAway({id: subscriber.email, title: subscriber.email}, 'delete')">
              Delete
            </button>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
  </section>
</template>

<script lang="js">
import {mapGetters, mapActions} from "vuex";
export default {
  name: 'ReadSubscriber',
  props: [],
  mounted () {},
  created () {
    this.readData()
      .then(data => this.subscribers = data)
      .catch()
  },
  data () {
    return {
      subscribers: null
    }
  },
  methods: {
    ...mapActions([
      'setCurrentElement',
      'setOperation',
      'setCrudComponent',
      'setPreviousOperation',
      'readData'
    ]),
    navigateAway(object, tab) {
      this.setCurrentElement(object);
      this.setPreviousOperation(this.getOperation);
      this.setOperation(tab);
      this.setCrudComponent('app-' + tab + '-' + this.getComponent);
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentElement',
      'getOperation',
      'getComponent'
    ])
  }
}
</script>

<style scoped lang="scss">
  .app-read-subscriber {}
</style>



// WEBPACK FOOTER //
// src/components/subscribers/ReadSubscriber.vue